import React, { useContext, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { AdminDashboardContext } from "../../../../../context/AdminDashboardContext";
import styles from "./AdminRadioInput.css";

const AdminRadioInput = ({
  name,
  simpleQuestionValue,
  initialValue,
  fieldToUpdate,
  setSpecificState = null,
}) => {
  const [selection, setSelection] = useState("");

  const { setUpdateProjectData } = useContext(AdminDashboardContext);

  const handleRadioChange = (value) => {
    switch (value) {
      case "da":
        sessionStorage.setItem(name, "da");
        break;
      case "ne":
        sessionStorage.setItem(name, "ne");
        break;
      default:
        break;
    }
    setSelection(value);
    if (setSpecificState) setSpecificState((prev) => !prev);

    setUpdateProjectData((prevState) => ({
      ...prevState,
      [fieldToUpdate]: value === "da",
    }));
  };

  useEffect(() => {
    let savedValue = sessionStorage.getItem(name);

    if (savedValue) {
      setSelection(savedValue);
    } else if (initialValue !== undefined) {
      if (initialValue === true) {
        setSelection("da");
      } else if (initialValue === false) {
        setSelection("ne");
      }
    }
  }, [initialValue, name]);

  return (
    <div className={styles.radioButtonContainer}>
      <p className={styles.simpleQuestionText}>{simpleQuestionValue}</p>
      <Form>
        <Form.Check
          type="radio"
          id="default-radio-da"
          label="Da"
          value="da"
          name="radioGroup"
          checked={selection === "da"}
          onChange={() => handleRadioChange("da")}
        />
        <Form.Check
          type="radio"
          id="default-radio-ne"
          label="Ne"
          value="ne"
          name="radioGroup"
          checked={selection === "ne"}
          onChange={() => handleRadioChange("ne")}
        />
      </Form>
    </div>
  );
};

export default AdminRadioInput;
